<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('help') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="downloadPdf">
                <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ទាញយក PDF
            </button>
        </div>
        <div class="x_body">
            <div ref="aboutContent" class="card f_card about-card">
                <div class="card-body">
                    <div class="about-header">
                        <div>
                            <h4>អំពីកម្មវិធី</h4>
                            <p>ប្រព័ន្ធគ្រប់គ្រងឱសថស្ថាន សម្រាប់ជួយការងារលក់ ទិញ ស្តុក គណនេយ្យ និងរបាយការណ៍ប្រចាំថ្ងៃ។</p>
                        </div>
                    </div>

                    <div class="about-section">
                        <h5>គោលបំណង</h5>
                        <p>
                            កម្មវិធីនេះត្រូវបានបង្កើតឡើងដើម្បីជួយឱ្យអាជីវកម្មឱសថស្ថានអាចគ្រប់គ្រងការងារបានងាយស្រួល
                            កាត់បន្ថយការកត់ត្រាដោយដៃ និងជួយឱ្យអ្នកប្រើប្រាស់មើលឃើញទិន្នន័យសំខាន់ៗបានឆាប់រហ័ស។
                        </p>
                    </div>

                    <div class="about-section">
                        <h5>មុខងារសំខាន់ៗ</h5>
                        <p>
                            ប្រព័ន្ធនេះរួមបញ្ចូលមុខងារចម្បងៗសម្រាប់គ្រប់គ្រងប្រតិបត្តិការរបស់ឱសថស្ថានពីដំណាក់កាលបញ្ចូលទិន្នន័យ
                            រហូតដល់ការចេញវិក្កយបត្រ ការគ្រប់គ្រងស្តុក និងការមើលរបាយការណ៍។
                        </p>
                    </div>

                    <div class="about-grid">
                        <div v-for="feature in features" :key="feature.title" class="about-item">
                            <i :class="feature.icon" aria-hidden="true"></i>
                            <div>
                                <strong>{{feature.title}}</strong>
                                <p>{{feature.description}}</p>
                                <ul>
                                    <li v-for="point in feature.points" :key="point">{{point}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="about-section">
                        <h5>ការប្រើប្រាស់ប្រចាំថ្ងៃ</h5>
                        <p>
                            អ្នកប្រើប្រាស់អាចចាប់ផ្តើមពីការបញ្ចូលទិន្នន័យមូលដ្ឋាន ដូចជា មុខទំនិញ អតិថិជន អ្នកផ្គត់ផ្គង់
                            និងសាខា។ បន្ទាប់មកអាចប្រើម៉ឺនុយលក់ ទិញ និងស្តុក ដើម្បីកត់ត្រាប្រតិបត្តិការប្រចាំថ្ងៃ។
                        </p>
                    </div>

                    <div class="workflow">
                        <div class="workflow-step">
                            <span>1</span>
                            <strong>រៀបចំទិន្នន័យមូលដ្ឋាន</strong>
                            <p>បញ្ចូលមុខទំនិញ ឯកតា តម្លៃ អតិថិជន អ្នកផ្គត់ផ្គង់ សាខា និងគណនីដែលត្រូវប្រើ។</p>
                        </div>
                        <div class="workflow-step">
                            <span>2</span>
                            <strong>កត់ត្រាប្រតិបត្តិការ</strong>
                            <p>បង្កើតការលក់ ការទិញ ការទទួលប្រាក់ ការបង់ប្រាក់ និងចលនាស្តុកប្រចាំថ្ងៃ។</p>
                        </div>
                        <div class="workflow-step">
                            <span>3</span>
                            <strong>ពិនិត្យ និងអនុម័ត</strong>
                            <p>ពិនិត្យស្ថានភាពឯកសារ ស្តុកនៅសល់ សមតុល្យ និងការបង់ប្រាក់ មុនពេលបិទប្រតិបត្តិការ។</p>
                        </div>
                        <div class="workflow-step">
                            <span>4</span>
                            <strong>មើលរបាយការណ៍</strong>
                            <p>ប្រើរបាយការណ៍ដើម្បីតាមដានការលក់ ការទិញ ចំណូល ចំណាយ ស្តុក និងលទ្ធផលអាជីវកម្ម។</p>
                        </div>
                    </div>

                    <div class="about-section">
                        <h5>អត្ថប្រយោជន៍សម្រាប់អ្នកប្រើប្រាស់</h5>
                        <div class="benefit-list">
                            <div><i class="fa fa-check-circle" aria-hidden="true"></i> កាត់បន្ថយការកត់ត្រាដោយដៃ និងកំហុសក្នុងការគណនា។</div>
                            <div><i class="fa fa-check-circle" aria-hidden="true"></i> មើលឃើញស្ថានភាពលក់ ស្តុក និងសមតុល្យបានលឿន។</div>
                            <div><i class="fa fa-check-circle" aria-hidden="true"></i> រក្សាទុកប្រវត្តិឯកសារ ដើម្បីងាយស្រួលស្វែងរក និងពិនិត្យឡើងវិញ។</div>
                            <div><i class="fa fa-check-circle" aria-hidden="true"></i> ជួយម្ចាស់អាជីវកម្ម និងបុគ្គលិកធ្វើការជាក្រុមបានមានរបៀបរៀបរយ។</div>
                        </div>
                    </div>

                    <div class="about-note">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <span>សូមរក្សាទិន្នន័យឱ្យបានត្រឹមត្រូវ និងពិនិត្យរបាយការណ៍ជាប្រចាំ ដើម្បីជួយការសម្រេចចិត្តក្នុងអាជីវកម្ម។</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake';

const PDF_TEXT_COLOR = '#0856ab';
const PDF_FONT_NAME = 'MuolLight';
const PDF_FONT_FILE = 'Moul-Regular.ttf';

export default {
    name: 'AboutProgram',
    data(){
        return {
            isPdfFontReady: false,
            features: [
                {
                    title: 'ទិន្នន័យមូលដ្ឋាន',
                    icon: 'fa fa-database',
                    description: 'រក្សាទុកទិន្នន័យសំខាន់ៗដែលត្រូវប្រើក្នុងប្រតិបត្តិការប្រចាំថ្ងៃ។',
                    points: ['មុខទំនិញ និងប្រភេទទំនិញ', 'ឯកតា តម្លៃ និងបាកូដ', 'អតិថិជន អ្នកផ្គត់ផ្គង់ និងសាខា']
                },
                {
                    title: 'ការលក់ និងវិក្កយបត្រ',
                    icon: 'fa fa-shopping-cart',
                    description: 'គ្រប់គ្រងដំណើរការលក់ចាប់ពីការបង្កើតឯកសាររហូតដល់ការទទួលប្រាក់។',
                    points: ['វិក្កយបត្រលក់ និងការបោះពុម្ព', 'បង្កាន់ដៃទទួលប្រាក់', 'តាមដានស្ថានភាពបង់ប្រាក់ និងសមតុល្យ']
                },
                {
                    title: 'ការទិញ និងអ្នកផ្គត់ផ្គង់',
                    icon: 'fa fa-truck',
                    description: 'គ្រប់គ្រងការទិញ ការទទួលទំនិញ និងការបង់ប្រាក់ជូនអ្នកផ្គត់ផ្គង់។',
                    points: ['បញ្ជាទិញ និងវិក្កយបត្រទិញ', 'ទទួលទំនិញចូលស្តុក', 'តាមដានបំណុល និងការទូទាត់']
                },
                {
                    title: 'ស្តុកទំនិញ',
                    icon: 'fa fa-cubes',
                    description: 'ជួយឱ្យដឹងច្បាស់ពីបរិមាណទំនិញនៅសល់ និងចលនាទំនិញក្នុងស្តុក។',
                    points: ['ទំនិញចូល និងទំនិញចេញ', 'កែតម្រូវស្តុក និងផ្ទេរស្តុក', 'ជូនដំណឹងទំនិញជិតអស់']
                },
                {
                    title: 'គណនេយ្យ',
                    icon: 'fa fa-book',
                    description: 'គាំទ្រការកត់ត្រាហិរញ្ញវត្ថុ និងការតាមដានចំណូលចំណាយ។',
                    points: ['ចំណូល និងចំណាយ', 'ទិនានុប្បវត្តិទូទៅ', 'គណនី និងរបាយការណ៍ហិរញ្ញវត្ថុ']
                },
                {
                    title: 'របាយការណ៍',
                    icon: 'fa fa-bar-chart',
                    description: 'ផ្តល់ព័ត៌មានសម្រាប់ពិនិត្យស្ថានភាពអាជីវកម្ម និងជួយសម្រេចចិត្ត។',
                    points: ['របាយការណ៍លក់ និងទិញ', 'របាយការណ៍ស្តុក', 'របាយការណ៍ចំណូល ចំណាយ និងសង្ខេប']
                },
                {
                    title: 'អ្នកប្រើប្រាស់ និងសិទ្ធិ',
                    icon: 'fa fa-users',
                    description: 'គ្រប់គ្រងអ្នកប្រើប្រាស់ និងកំណត់សិទ្ធិចូលប្រើមុខងារតាមតួនាទី។',
                    points: ['បង្កើត និងកែប្រែអ្នកប្រើប្រាស់', 'កំណត់ក្រុមអ្នកប្រើប្រាស់', 'ការពារទិន្នន័យតាមសិទ្ធិ']
                },
                {
                    title: 'ការកំណត់ប្រព័ន្ធ',
                    icon: 'fa fa-cogs',
                    description: 'កំណត់ព័ត៌មានក្រុមហ៊ុន រូបិយប័ណ្ណ ភាសា និងការកំណត់ផ្សេងៗសម្រាប់ប្រព័ន្ធ។',
                    points: ['ព័ត៌មានក្រុមហ៊ុន និងឡូហ្គោ', 'អត្រាប្តូរប្រាក់', 'ការកំណត់ភាសា និងម៉ឺនុយ']
                }
            ]
        }
    },
    methods: {
        async downloadPdf(){
            await this.preparePdfFont();
            const docDefinition = {
                pageSize: 'A4',
                pageMargins: [36, 34, 36, 34],
                defaultStyle: {
                    font: PDF_FONT_NAME,
                    fontSize: 10,
                    lineHeight: 1.35,
                    color: PDF_TEXT_COLOR
                },
                footer: function(currentPage, pageCount){
                    return {
                        columns: [
                            { text: 'ប្រព័ន្ធគ្រប់គ្រងឱសថស្ថាន', color: PDF_TEXT_COLOR, fontSize: 8 },
                            { text: currentPage + ' / ' + pageCount, alignment: 'right', color: PDF_TEXT_COLOR, fontSize: 8 }
                        ],
                        margin: [32, 0, 32, 0]
                    };
                },
                styles: {
                    title: {
                        color: PDF_TEXT_COLOR,
                        fontSize: 20,
                        bold: true,
                        margin: [0, 0, 0, 6]
                    },
                    subtitle: {
                        color: PDF_TEXT_COLOR,
                        fontSize: 10.5,
                        margin: [0, 0, 0, 12]
                    },
                    sectionTitle: {
                        color: PDF_TEXT_COLOR,
                        fontSize: 12.5,
                        bold: true,
                        margin: [0, 12, 0, 5]
                    },
                    cardTitle: {
                        bold: true,
                        color: PDF_TEXT_COLOR,
                        margin: [0, 0, 0, 4]
                    },
                    muted: {
                        color: PDF_TEXT_COLOR
                    }
                },
                content: [
                    { text: 'អំពីកម្មវិធី', style: 'title' },
                    {
                        text: 'ប្រព័ន្ធគ្រប់គ្រងឱសថស្ថាន សម្រាប់ជួយការងារលក់ ទិញ ស្តុក គណនេយ្យ និងរបាយការណ៍ប្រចាំថ្ងៃ។',
                        style: 'subtitle'
                    },
                    { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 523, y2: 0, lineWidth: 1.2, lineColor: '#dce7f5' }], margin: [0, 0, 0, 10] },
                    { text: 'គោលបំណង', style: 'sectionTitle' },
                    {
                        text: 'កម្មវិធីនេះត្រូវបានបង្កើតឡើងដើម្បីជួយឱ្យអាជីវកម្មឱសថស្ថានអាចគ្រប់គ្រងការងារបានងាយស្រួល កាត់បន្ថយការកត់ត្រាដោយដៃ និងជួយឱ្យអ្នកប្រើប្រាស់មើលឃើញទិន្នន័យសំខាន់ៗបានឆាប់រហ័ស។',
                        style: 'muted',
                        margin: [0, 0, 0, 8]
                    },
                    { text: 'មុខងារសំខាន់ៗ', style: 'sectionTitle' },
                    {
                        text: 'ប្រព័ន្ធនេះរួមបញ្ចូលមុខងារចម្បងៗសម្រាប់គ្រប់គ្រងប្រតិបត្តិការរបស់ឱសថស្ថានពីដំណាក់កាលបញ្ចូលទិន្នន័យ រហូតដល់ការចេញវិក្កយបត្រ ការគ្រប់គ្រងស្តុក និងការមើលរបាយការណ៍។',
                        style: 'muted',
                        margin: [0, 0, 0, 8]
                    },
                    this.featureGrid(),
                    { text: 'ការប្រើប្រាស់ប្រចាំថ្ងៃ', style: 'sectionTitle' },
                    {
                        text: 'អ្នកប្រើប្រាស់អាចចាប់ផ្តើមពីការបញ្ចូលទិន្នន័យមូលដ្ឋាន ដូចជា មុខទំនិញ អតិថិជន អ្នកផ្គត់ផ្គង់ និងសាខា។ បន្ទាប់មកអាចប្រើម៉ឺនុយលក់ ទិញ និងស្តុក ដើម្បីកត់ត្រាប្រតិបត្តិការប្រចាំថ្ងៃ។',
                        style: 'muted'
                    },
                    this.workflowGrid(),
                    { text: 'អត្ថប្រយោជន៍សម្រាប់អ្នកប្រើប្រាស់', style: 'sectionTitle' },
                    {
                        ul: [
                            'កាត់បន្ថយការកត់ត្រាដោយដៃ និងកំហុសក្នុងការគណនា។',
                            'មើលឃើញស្ថានភាពលក់ ស្តុក និងសមតុល្យបានលឿន។',
                            'រក្សាទុកប្រវត្តិឯកសារ ដើម្បីងាយស្រួលស្វែងរក និងពិនិត្យឡើងវិញ។',
                            'ជួយម្ចាស់អាជីវកម្ម និងបុគ្គលិកធ្វើការជាក្រុមបានមានរបៀបរៀបរយ។'
                        ],
                        margin: [12, 0, 0, 10],
                        color: PDF_TEXT_COLOR
                    },
                    this.noteCard('សូមរក្សាទិន្នន័យឱ្យបានត្រឹមត្រូវ និងពិនិត្យរបាយការណ៍ជាប្រចាំ ដើម្បីជួយការសម្រេចចិត្តក្នុងអាជីវកម្ម។')
                ]
            };
            pdfMake.createPdf(docDefinition).download('about-program.pdf');
        },
        async preparePdfFont(){
            if(this.isPdfFontReady) return;
            const response = await fetch(`/fonts/${PDF_FONT_FILE}`);
            const fontBuffer = await response.arrayBuffer();
            const fontBase64 = this.arrayBufferToBase64(fontBuffer);
            pdfMake.vfs = {
                ...(pdfMake.vfs || {}),
                [PDF_FONT_FILE]: fontBase64
            };
            pdfMake.fonts = {
                [PDF_FONT_NAME]: {
                    normal: PDF_FONT_FILE,
                    bold: PDF_FONT_FILE,
                    italics: PDF_FONT_FILE,
                    bolditalics: PDF_FONT_FILE
                }
            };
            this.isPdfFontReady = true;
        },
        arrayBufferToBase64(buffer){
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const chunkSize = 0x8000;
            for(let i = 0; i < bytes.length; i += chunkSize){
                const chunk = bytes.subarray(i, i + chunkSize);
                binary += String.fromCharCode.apply(null, chunk);
            }
            return window.btoa(binary);
        },
        coverBlock(){
            return {
                table: {
                    widths: ['*', 118],
                    body: [[
                        {
                            stack: [
                                { text: 'អំពីកម្មវិធី', style: 'title' },
                                {
                                    text: 'ប្រព័ន្ធគ្រប់គ្រងឱសថស្ថានសម្រាប់ការលក់ ការទិញ ស្តុក គណនេយ្យ និងរបាយការណ៍ប្រចាំថ្ងៃ។',
                                    style: 'subtitle'
                                },
                                {
                                    columns: [
                                        this.heroTag('ងាយស្រួលប្រើ'),
                                        this.heroTag('គ្រប់គ្រងច្បាស់'),
                                        this.heroTag('របាយការណ៍លឿន')
                                    ],
                                    columnGap: 6,
                                    margin: [0, 2, 0, 0]
                                }
                            ],
                            margin: [0, 0, 14, 0],
                            border: [false, false, false, false]
                        },
                        {
                            stack: [
                                { text: 'PHARMACY', alignment: 'center', color: '#0856ab', fontSize: 9, bold: true, margin: [0, 18, 0, 0] },
                                { text: 'MANAGEMENT', alignment: 'center', color: '#0856ab', fontSize: 9, bold: true },
                                { text: 'SYSTEM', alignment: 'center', color: '#0856ab', fontSize: 9, bold: true }
                            ],
                            fillColor: '#ffffff',
                            margin: [8, 8, 8, 8],
                            border: [false, false, false, false]
                        }
                    ]]
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 22]
            };
        },
        heroTag(text){
            return {
                text: text,
                alignment: 'center',
                color: PDF_TEXT_COLOR,
                fontSize: 8.5,
                margin: [0, 4, 0, 4],
                fillColor: '#eef6ff'
            };
        },
        valueStrip(){
            return {
                table: {
                    widths: ['*', '*', '*'],
                    body: [[
                        this.valueCell('ប្រើប្រាស់ប្រចាំថ្ងៃ', 'រៀបចំការលក់ ទិញ និងស្តុកក្នុងកន្លែងតែមួយ'),
                        this.valueCell('កាត់បន្ថយកំហុស', 'គណនាតម្លៃ សមតុល្យ និងស្ថានភាពឯកសារដោយប្រព័ន្ធ'),
                        this.valueCell('ចែករំលែកងាយ', 'បង្កើត PDF ស្អាត សម្រាប់បង្ហាញដល់អ្នកពាក់ព័ន្ធ')
                    ]]
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 12]
            };
        },
        valueCell(title, text){
            return {
                stack: [
                    { text: title, bold: true, color: '#0856ab', margin: [0, 0, 0, 4] },
                    { text: text, color: PDF_TEXT_COLOR, fontSize: 8.8 }
                ],
                fillColor: '#f4f9ff',
                margin: [8, 8, 8, 8]
            };
        },
        sectionHeading(text){
            return {
                columns: [
                    { width: 5, canvas: [{ type: 'rect', x: 0, y: 2, w: 5, h: 16, color: '#20a8d8' }] },
                    { width: '*', text: text, style: 'sectionTitle', margin: [7, 0, 0, 0] }
                ],
                margin: [0, 4, 0, 4]
            };
        },
        infoCard(text){
            return {
                table: {
                    widths: ['*'],
                    body: [[{
                        text: text,
                        color: PDF_TEXT_COLOR,
                        margin: [10, 8, 10, 8]
                    }]]
                },
                layout: {
                    hLineColor: () => '#dce7f5',
                    vLineColor: () => '#dce7f5',
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    fillColor: () => '#ffffff'
                },
                margin: [0, 0, 0, 8]
            };
        },
        noteCard(text){
            return {
                table: {
                    widths: ['*'],
                    body: [[{
                        text: text,
                        margin: [8, 7, 8, 7],
                        color: PDF_TEXT_COLOR
                    }]]
                },
                layout: {
                    hLineColor: () => '#dce7f5',
                    vLineColor: () => '#0856ab',
                    vLineWidth: index => index === 0 ? 4 : 1,
                    hLineWidth: () => 1,
                    fillColor: () => '#f8fbff'
                }
            };
        },
        featureGrid(){
            const rows = [];
            for(let i = 0; i < this.features.length; i += 2){
                rows.push([
                    this.featureCell(this.features[i]),
                    this.features[i + 1] ? this.featureCell(this.features[i + 1]) : { text: '' }
                ]);
            }
            return {
                table: {
                    widths: ['*', '*'],
                    body: rows
                },
                layout: this.cardLayout(),
                margin: [0, 0, 0, 8]
            };
        },
        featureCell(feature){
            return {
                stack: [
                    { text: feature.title, style: 'cardTitle' },
                    { text: feature.description, color: PDF_TEXT_COLOR, margin: [0, 0, 0, 4] },
                    { ul: feature.points, color: PDF_TEXT_COLOR, margin: [10, 0, 0, 0] }
                ],
                fillColor: '#ffffff',
                margin: [9, 8, 9, 8]
            };
        },
        workflowGrid(){
            const steps = [
                ['1', 'រៀបចំទិន្នន័យមូលដ្ឋាន', 'បញ្ចូលមុខទំនិញ ឯកតា តម្លៃ អតិថិជន អ្នកផ្គត់ផ្គង់ សាខា និងគណនីដែលត្រូវប្រើ។'],
                ['2', 'កត់ត្រាប្រតិបត្តិការ', 'បង្កើតការលក់ ការទិញ ការទទួលប្រាក់ ការបង់ប្រាក់ និងចលនាស្តុកប្រចាំថ្ងៃ។'],
                ['3', 'ពិនិត្យ និងអនុម័ត', 'ពិនិត្យស្ថានភាពឯកសារ ស្តុកនៅសល់ សមតុល្យ និងការបង់ប្រាក់ មុនពេលបិទប្រតិបត្តិការ។'],
                ['4', 'មើលរបាយការណ៍', 'ប្រើរបាយការណ៍ដើម្បីតាមដានការលក់ ការទិញ ចំណូល ចំណាយ ស្តុក និងលទ្ធផលអាជីវកម្ម។']
            ];
            return {
                table: {
                    widths: ['*', '*'],
                    body: [
                        [this.workflowCell(steps[0]), this.workflowCell(steps[1])],
                        [this.workflowCell(steps[2]), this.workflowCell(steps[3])]
                    ]
                },
                layout: this.cardLayout(),
                margin: [0, 8, 0, 8]
            };
        },
        workflowCell(step){
            return {
                stack: [
                    { text: step[0], color: PDF_TEXT_COLOR, fillColor: '#eef6ff', alignment: 'center', bold: true, margin: [0, 1, 0, 4] },
                    { text: step[1], color: PDF_TEXT_COLOR, bold: true, margin: [0, 0, 0, 4] },
                    { text: step[2], color: PDF_TEXT_COLOR }
                ],
                margin: [8, 7, 8, 7]
            };
        },
        benefitGrid(){
            const benefits = [
                ['កាត់បន្ថយការកត់ត្រាដោយដៃ', 'ជួយកាត់បន្ថយកំហុសក្នុងការគណនា និងការស្វែងរកឯកសារ។'],
                ['មើលស្ថានភាពបានលឿន', 'ដឹងពីការលក់ ស្តុក សមតុល្យ និងការបង់ប្រាក់បានឆាប់រហ័ស។'],
                ['រក្សាទុកប្រវត្តិឯកសារ', 'ងាយស្រួលស្វែងរក ពិនិត្យឡើងវិញ និងតាមដានប្រតិបត្តិការ។'],
                ['ធ្វើការជាក្រុមបានល្អ', 'ជួយម្ចាស់អាជីវកម្ម និងបុគ្គលិកធ្វើការតាមដំណើរការតែមួយ។']
            ];
            return {
                table: {
                    widths: ['*', '*'],
                    body: [
                        [this.benefitCell(benefits[0]), this.benefitCell(benefits[1])],
                        [this.benefitCell(benefits[2]), this.benefitCell(benefits[3])]
                    ]
                },
                layout: 'noBorders',
                margin: [0, 0, 0, 10]
            };
        },
        benefitCell(benefit){
            return {
                stack: [
                    { text: benefit[0], bold: true, color: PDF_TEXT_COLOR, margin: [0, 0, 0, 3] },
                    { text: benefit[1], color: PDF_TEXT_COLOR, fontSize: 8.8 }
                ],
                fillColor: '#f4fbf6',
                margin: [9, 8, 9, 8]
            };
        },
        closingBanner(){
            return {
                table: {
                    widths: ['*'],
                    body: [[{
                        text: 'សូមរក្សាទិន្នន័យឱ្យបានត្រឹមត្រូវ និងពិនិត្យរបាយការណ៍ជាប្រចាំ ដើម្បីជួយការសម្រេចចិត្តក្នុងអាជីវកម្ម។',
                        alignment: 'center',
                        color: PDF_TEXT_COLOR,
                        bold: true,
                        fillColor: '#eef6ff',
                        margin: [12, 10, 12, 10]
                    }]]
                },
                layout: 'noBorders'
            };
        },
        cardLayout(){
            return {
                hLineColor: () => '#e1e7ef',
                vLineColor: () => '#e1e7ef',
                hLineWidth: () => 1,
                vLineWidth: () => 1,
                paddingLeft: () => 0,
                paddingRight: () => 8,
                paddingTop: () => 0,
                paddingBottom: () => 8
            };
        }
    }
}
</script>

<style scoped>
    .about-card{
        max-width: 980px;
    }
    .about-header{
        border-bottom: 1px solid #e5e9ef;
        margin-bottom: 16px;
        padding-bottom: 12px;
    }
    .about-header h4{
        color: #0856ab;
        font-weight: 700;
        margin-bottom: 6px;
    }
    .about-header p,
    .about-section p,
    .about-item p{
        color: #555;
        line-height: 1.7;
        margin-bottom: 0;
    }
    .about-section{
        margin-bottom: 16px;
    }
    .about-section h5{
        color: #333;
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 6px;
    }
    .about-grid{
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(2, minmax(240px, 1fr));
        margin-bottom: 16px;
    }
    .about-item{
        border: 1px solid #e1e7ef;
        border-radius: 4px;
        display: flex;
        gap: 10px;
        padding: 12px;
    }
    .about-item i{
        color: #0856ab;
        font-size: 20px;
        margin-top: 2px;
        width: 24px;
    }
    .about-item strong{
        display: block;
        margin-bottom: 4px;
    }
    .about-item ul{
        color: #555;
        margin: 8px 0 0;
        padding-left: 18px;
    }
    .about-item li{
        line-height: 1.7;
    }
    .workflow{
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(4, minmax(150px, 1fr));
        margin-bottom: 16px;
    }
    .workflow-step{
        background: #fbfcfe;
        border: 1px solid #e1e7ef;
        border-radius: 4px;
        padding: 12px;
    }
    .workflow-step span{
        align-items: center;
        background: #0856ab;
        border-radius: 50%;
        color: #fff;
        display: flex;
        font-weight: 700;
        height: 26px;
        justify-content: center;
        margin-bottom: 8px;
        width: 26px;
    }
    .workflow-step strong{
        display: block;
        margin-bottom: 5px;
    }
    .workflow-step p{
        color: #555;
        line-height: 1.7;
        margin-bottom: 0;
    }
    .benefit-list{
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(2, minmax(240px, 1fr));
    }
    .benefit-list div{
        color: #444;
        line-height: 1.7;
    }
    .benefit-list i{
        color: #2f8f46;
        margin-right: 4px;
    }
    .about-note{
        align-items: flex-start;
        background: #f8fbff;
        border-left: 4px solid #0856ab;
        color: #444;
        display: flex;
        gap: 8px;
        line-height: 1.7;
        padding: 10px 12px;
    }
    .about-note i{
        color: #0856ab;
        margin-top: 4px;
    }
    @media (max-width: 767px){
        .about-grid,
        .workflow,
        .benefit-list{
            grid-template-columns: 1fr;
        }
    }
</style>
